import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const select_assessment = ({ event: { kind, data: { document_name } } }) =>
  <div className={kind}>
    {document_name && `${document_name} verified.`}
  </div>;

select_assessment.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      document_name: PropTypes.string,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/select_assessment.jsx